import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN,
    environment: process.env.APP_ENV,
    release: process.env.CIRCLE_BUILD_NUM,
    integrations: [new Integrations.BrowserTracing()],
    tracingOptions: {
      trackComponents: true,
    },
    tracesSampleRate: 1.0,
  });
}
